<template>
  <div class="firstentry">
    <div class="first-banner">
      <img :src="bannerImg" />
    </div>
    <div class="login-form">
      <div class="login-num flex space-between">
        <div class="flex">
          <div class="phone"><span class="iconfont icon-shouji"></span>手机号码</div>
          <input class="weui-input" type="tel" placeholder="填写手机号" maxlength="11" v-model="inputPhoneValue" @keyup="limtInput('number')" @blur="limtInput('number')" />
        </div>
        <div class="login-yzm" :class="[countDownTime ? 't_color' : '']" @click="getValidateCode">{{ validataCodeTxt }}</div>
      </div>
      <div class="login-num flex space-between">
        <div class="flex">
          <div class="code"><span class="iconfont icon-icon-test"></span>验证码</div>
          <input class="weui-input" type="tel" placeholder="输入验证码" maxlength="6" v-model="inputCodeValue" @keyup="limtInput('code')" @blur="limtInput('code')" />
        </div>
      </div>
    </div>
    <div class="first-btn">
      <mt-button class="fs_30 b_black register-btn" :class="{ isLoading: isLoading }" @click="register">注册</mt-button>
    </div>
    <!-- 协议部分 -->
    <div class="agreementPart">
      <div class="con">
        <i class="iconfont" :class="isAgree ? 'active icon-dagou' : 'icon-kuang'" @click="isAgree = !isAgree"></i>
        <span @click="isAgree = !isAgree">同意</span>
        <span class="link" @click="enterToDetail('userAgreement')">《用户协议》</span>与
        <span class="link" @click="enterToDetail('privacyAgreement')">《隐私协议》</span>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Indicator } from 'mint-ui'
import { UserRegister, GetTelCode } from '@/api/login'
import { mapMutations, mapGetters } from 'vuex'
import { IMG_BASE_URL } from '@/config/index'
export default {
  data() {
    return {
      inputPhoneValue: '',
      inputCodeValue: '',
      countDownTime: 0,
      validataCodeTxt: '获取验证码',
      timeOut: null,
      recommend: '',
      bannerImg: IMG_BASE_URL + '/upaiyun/Sys/20180508/5345284817510337341.png',
      isLoading: false,
      isAgree: false
    }
  },
  computed: {
    ...mapGetters(['sessionId'])
  },
  mounted() {
    if (this.$route.query.recommend) {
      this.recommend = this.$route.query.recommend
    }
  },
  methods: {
    ...mapMutations(['RECEIVE_SESSION_ID', 'RECEIVE_LOGIN_STATE']),
    // 验证手机号
    validataPhone() {
      let phoneNumber = this.inputPhoneValue
      if (phoneNumber.length <= 0) {
        Toast({
          message: '请输入手机号码',
          position: 'bottom'
        })
        return false
      } else {
        if (!/^1[3456789][0-9]{9}$/g.test(phoneNumber)) {
          Toast({
            message: '手机号码不存在',
            position: 'bottom'
          })
          return false
        } else {
          return true
        }
      }
    },
    limtInput(type) {
      if (type === 'number') {
        this.inputPhoneValue = this.inputPhoneValue.replace(/\D/gi, '')
      } else if (type === 'code') {
        this.inputCodeValue = this.inputCodeValue.replace(/\D/gi, '')
      }
    },
    // 倒计时
    countDown() {
      this.countDownTime = this.countDownTime - 1
      this.validataCodeTxt = this.countDownTime + 's后获取'
      if (this.countDownTime <= 0) {
        this.validataCodeTxt = '重新获取'
        clearInterval(this.timeOut)
      }
    },
    // 获取验证码
    getValidateCode: function() {
      if (this.countDownTime) return
      let phoneNumber = this.inputPhoneValue
      if (this.validataPhone()) {
        this.countDownTime = 60
        Indicator.open({
          text: '加载中',
          spinnerType: 'triple-bounce'
        })
        GetTelCode({ Tel: phoneNumber })
          .then((res) => {
            if (res) {
              if (res.Msg) {
                Toast({
                  message: '验证码已发送',
                  position: 'bottom'
                })
                this.timeOut = setInterval(this.countDown, 1000)
              }
            }
            Indicator.close()
          })
          .catch((err) => {
            Toast(err.ErrMsg)
            this.countDownTime = 0
            Indicator.close()
          })
      }
    },
    // 注册
    register() {
      if (this.isLoading) return
      // 优先判断用户是否已勾选【同意《用户协议》&《隐私协议》】，未勾选则给出toast提示：请先阅读并同意协议
      if (!this.isAgree) {
        Toast({
          message: '请先阅读并同意协议',
          position: 'bottom'
        })
        return
      }
      if (!this.validataPhone()) {
        return
      }
      if (this.inputCodeValue.length < 6) {
        Toast({
          message: '验证码不能小于6位数',
          position: 'bottom'
        })
        return
      }
      let params = {
        TelCode: this.inputCodeValue,
        Tel: this.inputPhoneValue,
        Recommend: this.recommend,
        tokenid: this.sessionId
      }
      this.isLoading = true
      UserRegister(params)
        .then((res) => {
          this.RECEIVE_SESSION_ID(res.Data.tokenid)
          this.RECEIVE_LOGIN_STATE(res.Data.isLogin)
          this.$router.go(-1)
          this.isLoading = false
        })
        .catch((err) => {
          this.isLoading = false
          Toast({
            message: err.ErrMsg,
            position: 'bottom'
          })
        })
    },
    enterToDetail(tempRouterName) {
      this.$router.push(tempRouterName)
    }
  }
}
</script>

<style scoped>
.flex {
  display: flex;
}
.space-between {
  justify-content: space-between;
}
.firstentry {
  width: 100%;
  height: 100%;
  font-size: 13px;
  background-color: #fff;
}
.first-banner img {
  width: 100%;
  height: 13em;
}
.first-btn {
  padding: 6% 6% 0 6%;
}
.first-btn .register-btn {
  width: 100%;
  letter-spacing: 5px;
}
.isLoading {
  opacity: 0.8;
}
.b_black {
  background: #2c2c2c;
  color: #fff;
}
.login-form {
  border: 1px solid #ddd;
  margin: 6% 6% 0 6%;
  border-radius: 5px;
  word-break: keep-all;
}
.login-num {
  line-height: 3.4em;
  height: 3.4em;
  font-size: 1em;
  padding: 0 0 0% 3%;
  border-bottom: 1px solid #ddd;
}
.login-num:last-child {
  border-bottom: none;
}
.login-num span {
  font-size: 1em;
  min-width: 6em;
}
.login-num input {
  line-height: 3.4em;
  height: 3.4em;
  width: 8em;
  margin-left: 10px;
  color: #999;
  font-size: 1em;
}
.login-num .phone {
  width: 5.8em;
  color: #666;
  font-size: 1em;
}
.login-num .phone .icon-shouji {
  font-size: 1.2em;
}
.login-num .code {
  width: 5.8em;
  color: #666;
  font-size: 1em;
}
.login-num .code .icon-icon-test {
  margin-right: 4%;
}
.login-num .iconfont {
  color: #666;
}
.login-yzm {
  border-left: 1px solid #ddd;
  line-height: 3.4em;
  height: 3.4em;
  min-width: 4.6em;
  text-align: center;
  font-size: 1em;
  color: #000;
  padding: 0 3%;
}
.t_color {
  color: #999;
}
.login-yzm:active {
  background: #fafafa;
}
</style>
